import {
  ExternalDimensioningTechnicalDataDllVersionTypename,
  ExternalDimensioningTechnicalDataTableTypename
} from "shared/types/ExternalDimensioning"
import {
  ExternalDimensioningResult,
  ExternalDimensioningTechnicalData,
  ExternalDimensioningTechnicalDataDllVersion,
  ExternalDimensioningTechnicalDataTable
} from "shared/types/__generated__/graphql"

export function patchExternalDimensioningTechnicalData(
  data: ExternalDimensioningTechnicalData
): ExternalDimensioningTechnicalData {
  if (
    Object.hasOwn(data, "type") &&
    (data as ExternalDimensioningTechnicalDataTable).type === "table"
  ) {
    return {
      ...(data as ExternalDimensioningTechnicalDataTable),
      __typename: ExternalDimensioningTechnicalDataTableTypename
    }
  }
  return {
    ...(data as ExternalDimensioningTechnicalDataDllVersion),
    __typename: ExternalDimensioningTechnicalDataDllVersionTypename
  }
}

export function patchExternalDimensioningResult(
  data: ExternalDimensioningResult
): ExternalDimensioningResult {
  return {
    ...data,
    technicalData: data.technicalData
      ? data.technicalData.map(tData =>
          patchExternalDimensioningTechnicalData(tData)
        )
      : null,
    __typename: "ExternalDimensioningResult"
  }
}
